import { render, staticRenderFns } from "./document-versions.vue?vue&type=template&id=c164a310&scoped=true&"
import script from "./document-versions.vue?vue&type=script&lang=js&"
export * from "./document-versions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c164a310",
  null
  
)

export default component.exports